import React from 'react';
import cx from 'classnames';
import Maybe from 'react-maybe';
import { useMenu, useSimpleLayout } from '@ers/hooks';
import Scrollbars from '../Scrollbars';
import { Media } from '..';
import Menu from './Menu';
import CloseTrigger from './CloseTrigger';

export default function Navigation() {
    const { state, close } = useMenu();
    const simpleLayout = useSimpleLayout();
    return (
        <>
            <Maybe
                of={simpleLayout}
                either={null}
                orElse={(
                    <>
                        <nav className={cx('nav', `nav${state}`)}>
                            <Media phone tabletPortrait>
                                <CloseTrigger onClick={close} />
                            </Media>
                            <Scrollbars>

                                <Menu />
                            </Scrollbars>
                        </nav>
                        <Media phone tabletPortrait>
                            <div className="shadow" onClick={close} />
                        </Media>
                    </>
                )}
            />
        </>
    );
}
